module.exports = __webpack_public_path__ + "img/zbicon.59023ce5.png";